/* eslint-disable no-console */

type LogArgs = unknown[];

const isDevelopment = import.meta.env.DEV;

export const logger = {
  debug: (...args: LogArgs) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },
  info: (...args: LogArgs) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  warn: (...args: LogArgs) => {
    console.warn(...args);
  },
  error: (...args: LogArgs) => {
    console.error(...args);
  },
};
